import { css } from 'styled-components';

import { badgeConsts } from './Badge.consts';
import { UseBadgePropsReturnType } from './Badge.utils';

export type BaseBadgeStylesProps = {
  $backgroundColor: UseBadgePropsReturnType['backgroundColor'];
  borderStyles: UseBadgePropsReturnType['borderStyles'];
  round: UseBadgePropsReturnType['round'];
  size: UseBadgePropsReturnType['size'];
};

export const BaseBadgeStyles = css<BaseBadgeStylesProps>`
  display: flex;
  justify-content: center;
  align-self: center;
  align-items: center;
  flex-direction: row;
  background-color: ${({ $backgroundColor }) => $backgroundColor};
  ${({ borderStyles }) => borderStyles}
  min-width: ${({ size }) => badgeConsts[size].size}px;
  min-height: ${({ size }) => badgeConsts[size].size}px;
  padding: ${({ round, size }) => (round ? 'unset' : `0 ${badgeConsts[size].paddingX}px`)};
`;
